import { Component } from '@angular/core';
import { AuthenticationService , HeaderService } from '../_services';
import { User } from '../_models';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent {

    public currentUser: User;

    constructor(
        private auth: AuthenticationService,
        private header: HeaderService
    ) {
        this.auth.currentUser.subscribe(x => this.currentUser = x);
        this.header.setHeader(true,true,true,true);
    }

  ngOnInit() {
    
    }
}
